import { FiscalDataLegalEntitiesErrorBoundary } from '@/pages/fiscal-data/legal-entities/legal-entities.error';

export default FiscalDataLegalEntitiesErrorBoundary;
